import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    Drawer,
    FormControl,
    FormControlLabel,
    Grid,
    Radio,
    RadioGroup,
    Slider,
    Switch,
    Typography,
} from '@material-ui/core';

import SubCard from '../../../../../Page/Dashboard/SubCard';
import { gridSpacing } from '../../../../constant';
import * as actionTypes from '../../../../../Redux/Action/BackboneAction';
import { RootReduxState } from '../../../../../Redux/Store';

function valuetext(value: number) {
    return `${value}px`;
}

const Customization = () => {
    const customization = useSelector((state: RootReduxState) => state.customization);
    const dispatch = useDispatch();
    const [open, setOpen] = React.useState(false);
    const [navType, setNavType] = React.useState(customization.navType);
    const [borderRadius, setBorderRadius] = React.useState(customization.borderRadius);
    const [ShowBreadcrumb, setShowBreadcrumb] = React.useState(customization.ShowBreadcrumb);

    const handleBorderRadius = (_event: unknown, newValue: number | number[]) => {
        setBorderRadius(typeof newValue === 'number' ? newValue : newValue[0]);
    };

    let initialFont;
    switch (customization.fontFamily) {
        case `'Inter', sans-serif`:
            initialFont = 'Inter';
            break;
        case `'Poppins', sans-serif`:
            initialFont = 'Poppins';
            break;
        case `'Roboto', sans-serif`:
        default:
            initialFont = 'Roboto';
            break;
    }

    const [fontFamily, setFontFamily] = React.useState(initialFont);

    const handleToggle = () => {
        setOpen(!open);
    };

    const HandleChangeShowBreadCum = (_event: React.ChangeEvent<{}>, checked: boolean) => {
        setShowBreadcrumb(checked)
    }

    if (customization.rtlLayout) {
        document.querySelector('body')!.setAttribute('dir', 'rtl');
    }
    useEffect(() => {
        if (customization.Customise_Sidebar_Open) {
            customization.Customise_Sidebar_Open = false;
            setOpen(true);
        }

    }, [customization, customization.Customise_Sidebar_Open]);
    useEffect(() => {
        dispatch({ type: actionTypes.SET_SHOW_BREADCRUMB, Data: ShowBreadcrumb });
    }, [dispatch, ShowBreadcrumb]);

    useEffect(() => {
        dispatch({ type: actionTypes.SET_BORDER_RADIUS, Data: borderRadius });
    }, [dispatch, borderRadius]);

    useEffect(() => {
        dispatch({ type: actionTypes.MENU_TYPE, Data: navType });
    }, [dispatch, navType]);

    useEffect(() => {
        let newFont;
        switch (fontFamily) {
            case 'Inter':
                newFont = `'Inter', sans-serif`;
                break;
            case 'Poppins':
                newFont = `'Poppins', sans-serif`;
                break;
            case 'Roboto':
            default:
                newFont = `'Roboto', sans-serif`;
                break;
        }
        dispatch({ type: actionTypes.SET_FONT_FAMILY, Data: newFont });
    }, [dispatch, fontFamily]);

    return (
        <React.Fragment>
            <Drawer
                anchor="right"
                onClose={handleToggle}
                open={open}
                PaperProps={{
                    style: {
                        padding: 20,
                        width: 280
                    }
                }}
            >
                <Grid container spacing={gridSpacing}>
                    <Grid item xs={12}>
                        <SubCard title="Layout" darkTitle>
                            <FormControl>
                                <RadioGroup
                                    row
                                    aria-label="layout"
                                    value={navType}
                                    onChange={(e) => setNavType(e.target.value)}
                                    name="row-radio-buttons-group"
                                >
                                    <FormControlLabel
                                        value="light"
                                        control={<Radio />}
                                        label="Light"
                                    />
                                    <FormControlLabel
                                        value="dark"
                                        control={<Radio />}
                                        label="Dark"

                                    />
                                </RadioGroup>
                            </FormControl>
                        </SubCard>
                    </Grid>
                    <Grid item xs={12}>
                        <SubCard title="Breadcrumb" darkTitle>
                            <FormControl>
                                <FormControlLabel
                                    checked={ShowBreadcrumb}
                                    onChange={HandleChangeShowBreadCum}
                                    control={<Switch />}
                                    label="Show"

                                />

                            </FormControl>
                        </SubCard>
                    </Grid>
                    <Grid item xs={12}>
                        <SubCard title="Font Family" darkTitle>
                            <FormControl>
                                <RadioGroup
                                    aria-label="font-family"
                                    value={fontFamily}
                                    onChange={(e) => setFontFamily(e.target.value)}
                                    name="row-radio-buttons-group"
                                >
                                    <FormControlLabel
                                        value="Roboto"
                                        control={<Radio />}
                                        label="Roboto"

                                    />
                                    <FormControlLabel
                                        value="Poppins"
                                        control={<Radio />}
                                        label="Poppins"

                                    />
                                    <FormControlLabel
                                        value="Inter"
                                        control={<Radio />}
                                        label="Inter"

                                    />
                                </RadioGroup>
                            </FormControl>
                        </SubCard>
                    </Grid>
                    <Grid item xs={12}>
                        <SubCard title="Border Radius" darkTitle>
                            <Grid item xs={12} container spacing={2} alignItems="center">
                                <Grid item>
                                    <Typography variant="h6" color="secondary">
                                        4px
                                    </Typography>
                                </Grid>
                                <Grid item xs>
                                    <Slider
                                        value={borderRadius}
                                        onChange={handleBorderRadius}
                                        getAriaValueText={valuetext}
                                        valueLabelDisplay="on"
                                        aria-labelledby="discrete-slider-small-steps"
                                        marks
                                        step={2}
                                        min={4}
                                        max={24}
                                        color="secondary"
                                    />
                                </Grid>
                                <Grid item>
                                    <Typography variant="h6" color="secondary">
                                        24px
                                    </Typography>
                                </Grid>
                            </Grid>
                        </SubCard>
                    </Grid>
                </Grid>
            </Drawer>
        </React.Fragment>
    );
};

export default Customization;
